import React from "react";
import axiosInstance, { getAccessToken } from "../axiosConfig";
import axios from "axios";
import { toast } from "react-toastify";
import FileSaver from "file-saver";

class TestimonialServices extends React.Component {

  getTestimonialList = async ({ queryKey }) => {
    const [_key, { name, company_name, search }] = queryKey;
    const response = await axiosInstance.get(`/api/testimonial`, {
      params: {
        name,
        company_name,
        search,
      },
    });
    return response;
  };
  addTestimonial = async (document) => {
    return await axiosInstance.post(`/api/testimonial/add`, document, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
  editTestimonial = async (id) => {
    return await axiosInstance.get(`/api/testimonial/edit/${id}`);
  };
  updateTestimonial = async (id, document) => {
    return await axiosInstance.post(`/api/testimonial/update/${id}`, document, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
  deactivateTestimonial = async (id, document) => {
    return await axiosInstance.post(`/api/testimonial/update-status/${id}`, document, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  };
}

const instance = new TestimonialServices();

export default instance;
